import styled, { css } from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { flexBetween, flexColumn } from '@/styles/common';

const commonLinkStyles = css`
  transition: color 0.3s ease;

  &:hover {
    color: var(--custom-yellow);
  }
`;

export const Wrapper = styled.footer<{
  $hasFixedBottomBar: boolean;
}>`
  width: 100%;
  background: var(--bg-main);
  padding: 100px 80px 50px;
  ${flexColumn};
  gap: 40px;

  ${({ $hasFixedBottomBar }) =>
    $hasFixedBottomBar &&
    css`
      padding-bottom: 130px;
    `};

  @media (max-width: ${BREAKPOINTS.desktop}) {
    padding-bottom: ${({ $hasFixedBottomBar }) =>
      $hasFixedBottomBar ? '130px' : '50px'};
  }

  @media (max-width: ${BREAKPOINTS.laptop}) {
    border-top: 1px solid var(--border-main);
    padding-top: 20px;
    padding-inline: 40px;
    align-items: flex-start;
    gap: 25px;
  }

  @media (max-width: ${BREAKPOINTS.mobile}) {
    padding-inline: 16px;
  }
`;

export const Section = styled.div`
  ${flexBetween};
  align-items: flex-start;

  @media (max-width: ${BREAKPOINTS.laptop}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Divider = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid var(--border-main);
`;

export const ContactsWrapper = styled.div`
  display: flex;
  gap: 40px;

  @media (max-width: ${BREAKPOINTS.laptop}) {
    margin-top: 30px;
    flex-direction: column;
    gap: 20px;

    > :nth-child(3) {
      order: 2;
    }

    > :nth-child(4) {
      order: 1;
    }
  }
`;

export const ContactItem = styled(Typography).attrs({ variant: 'title4' })`
  color: var(--textAndLabels-main);
  ${commonLinkStyles}
`;

export const CopyRight = styled(Typography).attrs({ variant: 'body3' })`
  color: var(--textAndLabels-tertiary);

  @media (max-width: ${BREAKPOINTS.laptop}) {
    margin-top: 20px;
    order: 1;
  }
`;

export const LinksWrapper = styled.div`
  display: flex;
  gap: 20px;

  @media (max-width: ${BREAKPOINTS.laptop}) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const FooterLink = styled(Typography).attrs({ variant: 'body3' })`
  width: max-content;
  color: var(--textAndLabels-tertiary);
  ${commonLinkStyles}
`;
